export default (theme) => {
  return {
    renameButton: {
      height: 15,
      fontSize: 11,
    },
  }
}
